import { render } from "./RadioGroup.vue?vue&type=template&id=e4845042&scoped=true&lang=pug"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=e4845042&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4845042"]])

export default __exports__